import { type FC } from "react";

import { t } from "i18n/i18n";
import { IconText } from "mds/components/IconText";
import { Menu, MenuLinkItem } from "mds/components/Menu";
import { SquareButton } from "mds/components/buttons/SquareButton";
import { BookSectionLinkedIcon, ChevronDownIcon } from "mds/icons";
import { sectionSelectors, selectLinkedSectionIdsForCurrentSection } from "store/selectors";
import { useListSelector, useObjectSelector } from "store/store-hooks";
import { sectionHomeUrl } from "utils/urls";

const LinkedSectionMenuItem: FC<{ sectionId: string }> = ({ sectionId }) => {
  const section = useObjectSelector((s) => sectionSelectors.selectById(s, sectionId), ["title"]);

  if (!section) {
    return null;
  }

  return <MenuLinkItem to={sectionHomeUrl(sectionId)}>{section.title}</MenuLinkItem>;
};

export const LinkedSectionsMenu: FC = () => {
  const linkedSectionIds = useListSelector(selectLinkedSectionIdsForCurrentSection);
  const label = t("section_view.template_linked_sections", { count: linkedSectionIds.length });
  const iconText = (
    <IconText
      className="text-xs font-medium text-black-tint-40"
      iconEnd={linkedSectionIds.length > 0 ? <ChevronDownIcon /> : undefined}
      iconStart={<BookSectionLinkedIcon />}
      text={label}
    />
  );

  if (linkedSectionIds.length === 0) {
    return iconText;
  }

  return (
    <Menu
      align="start"
      menuButton={
        <SquareButton kind="ghost" size="xs">
          {iconText}
        </SquareButton>
      }
    >
      {linkedSectionIds.map((sectionId) => (
        <LinkedSectionMenuItem key={sectionId} sectionId={sectionId} />
      ))}
    </Menu>
  );
};
